// extracted by mini-css-extract-plugin
export default {"link":"AKsHlS","ScotchTapeButton":"g417GQ","scotchTapeButton":"g417GQ","label":"w5nZh8","left":"N2k30m","right":"UidcSX"};